import React, { Component } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import get from 'lodash/get'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions.jsx'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import { connect } from 'react-redux'
import moment from 'moment'
import MPZLinkPicker from './LinkPicker.jsx'
import TextFunctions from '~/Classes/textFunctions'

//CONNECT TO STORE
@connect((store) => {
    return { user: store.user }
})
export default class ComponentText extends Component {
    constructor(props) {
        super(props)
        this.change = this.change.bind(this)
        this.changeAndCommit = this.changeAndCommit.bind(this)
        this.getValue = this.getValue.bind(this)
        this.openLinkPicker = this.openLinkPicker.bind(this)
        this.hideExternalPickers = this.hideExternalPickers.bind(this)
        this.pickNewLink = this.pickNewLink.bind(this)
        this.toggleHidePickers = this.toggleHidePickers.bind(this)

        // Store the focusout handler so the same reference is used for add/remove
        this.onFocusOut = (event) => this.elementDidBlur(event)

        this.state = {
            value: '',
            showLinkPicker: false,
            isDropDown: false,
            dropDownOptions: []
        }
    }

    componentDidMount() {
        const el = document.getElementById('ourInput_' + this.props.path)
        if (el) {
            el.addEventListener('focusout', this.onFocusOut)
        }
        this.getValue()
    }
    componentWillUnmount() {
        const el = document.getElementById('ourInput_' + this.props.path)
        if (el) {
            el.removeEventListener('focusout', this.onFocusOut)
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.elementData?.linkedToCustomField && this.props.elementData?.linkedToCustomField) {
            try {
                var linkedFieldLocation = this.props.elementData.linkedToCustomField.replace('_localVariables_.', '')
                var prevLinkedFieldLocation = prevProps.elementData.linkedToCustomField.replace('_localVariables_.', '')
                var ourCustomFieldName = get(this.props.elementsData, this.props.selectedElement.path).localVariables[
                    linkedFieldLocation
                ].value
                var prevOurCustomFieldName = get(prevProps.elementsData, prevProps.selectedElement.path).localVariables[
                    prevLinkedFieldLocation
                ].value
                if (ourCustomFieldName != prevOurCustomFieldName) {
                    this.getValue()
                }
            } catch (error) {
                console.error(error)
            }
        }
    }

    getValue() {
        try {
            var thisValue = this.props.value
            let isDropDown = false
            let isDropDownOptions = []
            if (this.props.elementData.linkedToCustomField) {
                var linkedFieldLocation = this.props.elementData.linkedToCustomField.replace('_localVariables_.', '')
                //get the current custom field

                var ourCustomFieldName = get(this.props.elementsData, this.props.selectedElement.path).localVariables[
                    linkedFieldLocation
                ].value

                //lookup the custom field in the custom fields
                var ourCustomField = DragDropFunctions.customFields[ourCustomFieldName]
                if (ourCustomField && ourCustomField.type && ourCustomField.type == 'BOOLEAN') {
                    thisValue = thisValue + ''
                    if (thisValue != '1' && thisValue != '0') thisValue = '1'
                    isDropDown = true
                    isDropDownOptions = [
                        { label: 'Yes', value: '1' },
                        { label: 'No', value: '0' }
                    ]
                }
            }
            this.setState({ value: thisValue, isDropDown: isDropDown, dropDownOptions: isDropDownOptions })
        } catch (error) {
            console.error(error)
        }
    }
    elementDidBlur(event) {
        var ourFieldSubType = (
            this.props.elementData && this.props.elementData.editableSubType
                ? this.props.elementData.editableSubType
                : 'text'
        ).toLowerCase()
        var ourVal = event.currentTarget.value
        if (ourFieldSubType == 'link' || this.props.inputType == 'link') {
            if (
                ourVal &&
                ourVal.length > 3 &&
                ourVal.indexOf('http://') < 0 &&
                ourVal.indexOf('https://') < 0 &&
                ourVal.indexOf('mailto:') < 0 &&
                ourVal.indexOf('{{') !== 0
            ) {
                if (ourVal.indexOf('@') > 0) {
                    ourVal = 'mailto:' + ourVal
                } else {
                    ourVal = 'http://' + ourVal
                }
            }
        }
        if (typeof ourVal === 'string') {
            ourVal = TextFunctions.removeScriptCapableTags(ourVal)
        }
        this.setState({ value: ourVal })
        this.props.updateVal(this.props.path, ourVal)
    }

    change(event, date, updateVal) {
        var thisVal = event ? event.currentTarget.value : date
        if (typeof thisVal === 'string') {
            thisVal = thisVal.replace(/</g, '&lt;').replace(/>/g, '&gt;')
        }
        this.setState({ value: thisVal })
        if (updateVal || (!event && date)) {
            this.props.updateVal(this.props.path, thisVal)
        }
    }

    changeAndCommit(event) {
        this.change(event, false, true)
    }

    openLinkPicker() {
        this.setState({ showLinkPicker: true })
    }
    hideExternalPickers() {
        this.setState({ showLinkPicker: false })
    }

    pickNewLink(value) {
        this.setState({ value: value, showLinkPicker: false })
        this.props.updateVal(this.props.path, value)
    }
    toggleHidePickers() {}
    render() {
        //if this element is linked to a custom field, lookup the custom field type.
        //if the custom field type is BOOL do something

        var ourFieldSubType = (
            this.props.elementData && this.props.elementData.editableSubType
                ? this.props.elementData.editableSubType
                : 'text'
        ).toLowerCase()
        var style = {}
        if (this.props.elementData.optionFullWidth) style = { flex: '100%' }

        if (this.state.isDropDown && this.state.dropDownOptions.length > 0) {
            return (
                <div className='dndEditorv2-dd_toolHolder' style={style}>
                    <div className='dd_inputTool'>
                        <Select
                            label={this.props.title}
                            data={this.state.dropDownOptions}
                            value={this.state.value}
                            onChange={(ev) => {
                                this.change(ev, false, true)
                            }}
                            onClose={() => {}}
                        />
                    </div>
                </div>
            )
        }

        var fieldTypeProps = {
            type: 'text',
            placeholder: this.props.title
        }

        let fieldValue = this.state.value
        if (ourFieldSubType) {
            if (ourFieldSubType == 'time') {
                fieldTypeProps.type = 'time'
                fieldTypeProps.placeholder = '00:00:00'
            }
            if (ourFieldSubType == 'date') {
                fieldTypeProps.type = 'date'
                fieldTypeProps.placeholder = 'yyyy/mm/dd'
                if (!moment(fieldValue).isValid()) fieldValue = ''
            }
            if (ourFieldSubType == 'datetime') {
                fieldTypeProps.type = 'datetime'
                fieldTypeProps.dateFormat = 'YYYY/MM/DD'
                fieldTypeProps.placeholder = 'yyyy/mm/dd 00:00'
                if (!moment(fieldValue).isValid()) fieldValue = ''
            }
        }

        if (this.props.elementData.inputPlaceHolder)
            fieldTypeProps.placeholder = this.props.elementData.inputPlaceHolder

        var inputStyle = {}
        if (ourFieldSubType == 'link' || this.props.inputType == 'link') {
            inputStyle.cursor = 'pointer'
        }

        if (ourFieldSubType == 'link') {
            style.display = 'block'
        }

        let theTitle = this.props.title
        if (this.props.elementData.toolTip) {
            theTitle = (
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    {theTitle}
                    <Icons
                        icon='questionCircle'
                        className='mar-l5'
                        style={{ width: 16, height: 16, cursor: 'pointer' }}
                        data-tooltip-content={this.props.elementData.toolTip}
                        data-tooltip-id='toggle-tooltip'
                        data-tooltip-style={{ maxWidth: '200px', zIndex: 99999 }}
                        data-tooltip-position='right'
                    />
                </div>
            )
        }
        let outerClass = 'dndEditorv2-dd_toolHolder'
        if (this.props.elementData.optionHalfWidth) outerClass += ' dndEditorv2-dd_toolHolder-half'
        const changeHandler = this.props.updateOnChange ? this.changeAndCommit : this.change
        return (
            <div className={outerClass} style={style}>
                {ourFieldSubType != 'link' && (
                    <div className='dd_inputTool'>
                        <TextInput
                            datePopperContainer={
                                ourFieldSubType == 'date' || ourFieldSubType == 'datetime' ? true : false
                            }
                            label={theTitle}
                            {...fieldTypeProps}
                            value={fieldValue}
                            onChange={ourFieldSubType != 'link' ? changeHandler : () => {}}
                            onClick={ourFieldSubType != 'link' ? this.change : () => {}}
                            style={inputStyle}
                            readOnly={ourFieldSubType == 'link'}
                            id={'ourInput_' + this.props.path}
                        />
                    </div>
                )}

                {ourFieldSubType == 'link' && (
                    <MPZLinkPicker
                        save={this.pickNewLink}
                        currVal={this.state.value}
                        close={this.hideExternalPickers}
                        toggleHidePickers={this.toggleHidePickers}
                        elementsData={this.props.elementsData}
                        inline={true}
                        isLandingPage={this.props.isLandingPage}
                    />
                )}
            </div>
        )
    }
}
